import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=789e014f&scoped=true&"
import script from "./Alertas.vue?vue&type=script&lang=ts&"
export * from "./Alertas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e014f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('789e014f', component.options)
    } else {
      api.reload('789e014f', component.options)
    }
    module.hot.accept("./Alertas.vue?vue&type=template&id=789e014f&scoped=true&", function () {
      api.rerender('789e014f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlConfiguracion/Configuraciones/Alertas.vue"
export default component.exports